import { useDispatch, useSelector } from 'react-redux';
import { getModal } from '../selectors/ModalsSelector';
import PostPublishModal from '../components/modals/PostPublishModal';
import { ModalTypes, hideModal } from '../redux/actions/ModalActions';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ModalsContainer() {
  const modal = useSelector(getModal);
  const dispatch = useDispatch();
  const onClose = () => dispatch(hideModal());
  if (!modal) {
    return;
  }
  if (modal.modal === ModalTypes.POST_PUBLISH) {
    return /*#__PURE__*/_jsx(PostPublishModal, Object.assign({}, modal.props, {
      onClose: onClose
    }));
  }
}